// Route
const afterLoginRedirectUrlKey = 'after_login_redirect_url';
export const getAfterLoginRedirectUrl = () =>
  localStorage.getItem(afterLoginRedirectUrlKey);
export const setAfterLoginRedirectUrl = (afterLoginRedirectUrl: string) =>
  localStorage.setItem(afterLoginRedirectUrlKey, afterLoginRedirectUrl);
export const removeAfterLoginRedirectUrl = () =>
  localStorage.removeItem(afterLoginRedirectUrlKey);

// App
const sidebarStatusKey = 'sidebar_status';
export const getSidebarStatus = () => localStorage.getItem(sidebarStatusKey);
export const setSidebarStatus = (sidebarStatus: string) =>
  localStorage.setItem(sidebarStatusKey, sidebarStatus);

const languageKey = 'language';
export const getLanguage = () => localStorage.getItem(languageKey);
export const setLanguage = (language: string) =>
  localStorage.setItem(languageKey, language);

const themeKey = 'theme';
export const getTheme = () => localStorage.getItem(themeKey);
export const setTheme = (theme: string) =>
  localStorage.setItem(themeKey, theme);

// Booking
const bookingSearchFormKey = 'boooking_search_form';
export const getBookingSearchForm = () =>
  localStorage.getItem(bookingSearchFormKey);
export const setBookingSearchForm = (bookingSearchForm: string) =>
  localStorage.setItem(bookingSearchFormKey, bookingSearchForm);
export const removeBookingSearchForm = () =>
  localStorage.removeItem(bookingSearchFormKey);

const bookingIssueTicketReceiptKey = 'boooking_issue_ticket_reecipt';
export const getBookingIssueTicketReceipt = () =>
  localStorage.getItem(bookingIssueTicketReceiptKey);
export const setBookingIssueTicketReceipt = (issueTicketReceipt: string) =>
  localStorage.setItem(bookingIssueTicketReceiptKey, issueTicketReceipt);
export const removeBookingIssueTicketReceipt = () =>
  localStorage.removeItem(bookingIssueTicketReceiptKey);

// Report
const reportSearchFormKey = 'report_search_form';
export const getReportSearchForm = () =>
  localStorage.getItem(reportSearchFormKey);
export const setReportSearchForm = (reportSearchForm: string) =>
  localStorage.setItem(reportSearchFormKey, reportSearchForm);
export const removeReportSearchForm = () =>
  localStorage.removeItem(reportSearchFormKey);

// Ticket Setting
const ticketSettingListSearchFormKey = 'ticket_setting_list_search_form';
export const getTicketSettingListSearchForm = () =>
  localStorage.getItem(ticketSettingListSearchFormKey);
export const setTicketSettingListSearchForm = (
  ticketSettingListSearchForm: string
) =>
  localStorage.setItem(
    ticketSettingListSearchFormKey,
    ticketSettingListSearchForm
  );
export const removeTicketSettingListSearchForm = () =>
  localStorage.removeItem(ticketSettingListSearchFormKey);

// User
const userTokenKey = 'user_token';
export const getUserToken = () => localStorage.getItem(userTokenKey);
export const setUserToken = (token: string) =>
  localStorage.setItem(userTokenKey, token);
export const removeUserToken = () => localStorage.removeItem(userTokenKey);

const supplierIdsKey = 'supplier_ids';
export const getSupplierIds = () => localStorage.getItem(supplierIdsKey);
export const setSupplierIds = (supplierIds: string) =>
  localStorage.setItem(supplierIdsKey, supplierIds);
export const removeSupplierIds = () => localStorage.removeItem(supplierIdsKey);
